<script setup>
import { onMounted, ref } from 'vue';
import { PhxCrownNavigation } from '@phx-styleguides/iwc';

const props = defineProps({
  anchors: {
    type: Array,
    required: true,
  },
});

const rootRef = ref(null);
const sections = props.anchors
  .map((anchor) => {
    const name = anchor.href.startsWith('#') ? anchor.href.slice(1) : anchor.href;
    return document.querySelector(`.anchor[name="${name}"]`);
  })
  .filter((section) => section);

const enableIntersectionObserver = () => {
  const options = {
    threshold: 0.5,
  };
  const callback = (entries) => {
    entries.forEach((entry) => {
      const fromTop = entry.intersectionRect.top;
      const fromBottom = entry.rootBounds.height - entry.intersectionRect.bottom;
      // Prevent first section observer on load
      if (entry.intersectionRatio === 1 && window.scrollTop === 0) {
        return;
      }
      if (fromTop > fromBottom && entry.isIntersecting === true) {
        rootRef.value.rotate('down');
      }
      if (fromBottom > fromTop && entry.isIntersecting === true) {
        rootRef.value.rotate('up');
      }
    });
  };
  const observer = new IntersectionObserver(callback, options);
  sections.forEach((element) => observer.observe(element));
};

const onClickItem = () => {
  rootRef.value.close();
};

onMounted(() => {
  enableIntersectionObserver();
});
</script>

<template>
  <phx-crown-navigation
    id="cluster-page-crown"
    ref="rootRef"
    root-class="cluster-page__crown-navigation"
    :anchors="anchors"
    @item:click="onClickItem"
  />
</template>
